module.exports = __webpack_public_path__ + "img/game--battlefield-2042.d9e5ab5c.png";